module.exports = __webpack_public_path__ + "images/style-9-7209df110690c8cd1007b6e86d785622.jpg";